// ── sopDefaults.js — 매장 운영 매뉴얼 기본값 ─────────────────
// 한식 음식점 표준 SOP. 사용자가 본인 매장에 맞게 자유 수정.
// ManualPage > 오픈·영업·마감 매뉴얼 화면에서 사용.
//
// 구조:
//   { open, during, close } 각 섹션:
//     label : 섹션 제목 (인쇄 시 헤더)
//     items : 순서대로 체크리스트 항목들
//   각 item: { id, title, time?(선택), note?(선택) }
//   - time: 오픈 섹션은 "T-30분" 같은 상대시간 / 마감은 시간 비워둠
//   - note: 부연 설명 (생략 가능)

export const SOP_DEFAULT = {
  open: {
    label: '오픈 (영업 시작 1시간 전부터)',
    items: [
      { id: 'o1',  time: 'T-60분', title: '출근·손 씻기·위생복 착용',                              note: '비누 30초 이상' },
      { id: 'o2',  time: 'T-60분', title: '간판·실내 조명 켜기',                                    note: '' },
      { id: 'o3',  time: 'T-55분', title: '냉장고 온도 확인',                                       note: '냉장 0~4℃ / 냉동 -18℃ 이하' },
      { id: 'o4',  time: 'T-55분', title: '가스 밸브 열기·환풍 후드 가동',                          note: '가스 누설 냄새 점검' },
      { id: 'o5',  time: 'T-50분', title: '어제 잔여 식재료 상태 점검',                             note: '변색·냄새·곰팡이 즉시 폐기' },
      { id: 'o6',  time: 'T-45분', title: '오늘 사용할 식재료 손질·밑준비',                         note: '재료 가격표 옆에 비치' },
      { id: 'o7',  time: 'T-30분', title: '밥솥 취사 시작',                                         note: '' },
      { id: 'o8',  time: 'T-30분', title: '국·찌개 끓이기 시작',                                    note: '' },
      { id: 'o9',  time: 'T-20분', title: '반찬 그릇 채우기·수저 세팅',                             note: '' },
      { id: 'o10', time: 'T-15분', title: '테이블·바닥·화장실 청소 점검',                           note: '' },
      { id: 'o11', time: 'T-10분', title: 'POS·결제기 켜기·시재(현금) 확인',                       note: '잔돈 5만원 정도' },
      { id: 'o12', time: 'T-5분',  title: '메뉴판·POP 위치 점검',                                   note: '' },
      { id: 'o13', time: '0분',    title: '오픈 — 출입문 열기',                                     note: '' },
    ],
  },
  during: {
    label: '영업 중 (반복하는 일)',
    items: [
      { id: 'd1',  time: '', title: '주문 받기 — 한 번 더 복창해서 확인',                           note: '' },
      { id: 'd2',  time: '', title: '주방에 주문 전달 (또는 POS 출력)',                              note: '' },
      { id: 'd3',  time: '', title: '물·반찬 1차 세팅',                                              note: '' },
      { id: 'd4',  time: '', title: '메뉴 서빙',                                                     note: '' },
      { id: 'd5',  time: '', title: '식기 회수 → 즉시 세척·소독',                                   note: '' },
      { id: 'd6',  time: '', title: '결제 처리 (현금·카드·배달앱) + 영수증 보관',                    note: '영수증 한 통에 모으기' },
      { id: 'd7',  time: '', title: '화장실 점검 (1시간마다)',                                       note: '' },
      { id: 'd8',  time: '', title: '반찬 잔량 수시 확인·보충',                                      note: '' },
      { id: 'd9',  time: '', title: '손 자주 씻기·행주 30분마다 교체',                              note: '' },
      { id: 'd10', time: '', title: '바닥 흘림·테이블 즉시 정리',                                    note: '' },
    ],
  },
  close: {
    label: '마감 (영업 종료 후)',
    items: [
      { id: 'c1',  time: '', title: '마지막 손님 결제 완료 확인',                                    note: '' },
      { id: 'c2',  time: '', title: '가스 밸브 잠그기',                                              note: '두 번 확인' },
      { id: 'c3',  time: '', title: '환풍 후드 청소',                                                note: '기름때 제거' },
      { id: 'c4',  time: '', title: '남은 음식 보관 — 날짜 라벨 붙이기',                             note: '냉장 2일 이내 사용' },
      { id: 'c5',  time: '', title: '사용한 식기 모두 세척·소독 완료',                                note: '' },
      { id: 'c6',  time: '', title: '바닥·테이블 청소·의자 올리기',                                  note: '' },
      { id: 'c7',  time: '', title: '음식물·일반 쓰레기 분리 배출',                                  note: '' },
      { id: 'c8',  time: '', title: '화장실 청소',                                                   note: '' },
      { id: 'c9',  time: '', title: 'POS 정산 — 현금·카드·배달앱 합계',                              note: '시재 차이 즉시 메모' },
      { id: 'c10', time: '', title: '오늘 매출 셈핏에 입력',                                         note: '운영 → 매출 입력' },
      { id: 'c11', time: '', title: '내일 사용할 식재료 확인 → 부족분 발주서 작성',                  note: '단가표 보고 거래처별로' },
      { id: 'c12', time: '', title: '냉장고 온도 재확인',                                            note: '' },
      { id: 'c13', time: '', title: '조명·간판 전원 끄기',                                           note: '' },
      { id: 'c14', time: '', title: '가스 밸브 재확인',                                              note: '잠금 상태 다시 점검' },
      { id: 'c15', time: '', title: '출입문 잠그기',                                                 note: '' },
    ],
  },
};

export const SOP_SECTIONS = ['open', 'during', 'close'];

// ── V147: 중국어 화면용 기본값 (중국 매장 · 韩国餐厅) ─────────────────────────────
// 중국어로 볼 때 저장된 중국어 매뉴얼(sopChecklist_zh)이 없으면 이것을 쓴다.
// 한국어 매뉴얼(sopChecklist)과 따로 저장된다.
export const SOP_DEFAULT_ZH = {
  open: {
    label: '开店（营业前 1 小时开始）',
    items: [
      { id: 'o1',  time: 'T-60分', title: '到店 · 洗手 · 穿工作服',                note: '用肥皂洗 30 秒以上' },
      { id: 'o2',  time: 'T-60分', title: '打开招牌和店内灯',                       note: '' },
      { id: 'o3',  time: 'T-55分', title: '检查冰箱温度',                           note: '冷藏 0~4℃ / 冷冻 -18℃ 以下' },
      { id: 'o4',  time: 'T-55分', title: '打开燃气阀 · 开排烟罩',                   note: '检查有没有燃气味' },
      { id: 'o5',  time: 'T-50分', title: '检查昨天剩下的食材',                     note: '变色 · 有异味 · 发霉的马上扔掉' },
      { id: 'o6',  time: 'T-45分', title: '处理今天要用的食材 · 备料',               note: '' },
      { id: 'o7',  time: 'T-30分', title: '电饭锅开始煮饭',                         note: '' },
      { id: 'o8',  time: 'T-30分', title: '开始煮汤 · 炖锅',                         note: '' },
      { id: 'o9',  time: 'T-20分', title: '装好小菜 · 摆好餐具',                     note: '' },
      { id: 'o10', time: 'T-15分', title: '检查桌子 · 地面 · 洗手间卫生',             note: '' },
      { id: 'o11', time: 'T-10分', title: '打开收银机 · 确认备用零钱',               note: '' },
      { id: 'o12', time: 'T-5分',  title: '检查菜单 · 海报位置',                     note: '' },
      { id: 'o13', time: '0分',    title: '开门营业',                               note: '' },
    ],
  },
  during: {
    label: '营业中（反复做的事）',
    items: [
      { id: 'd1',  time: '', title: '点单 — 再复述一遍确认',                        note: '' },
      { id: 'd2',  time: '', title: '把订单交给厨房（或打印小票）',                  note: '' },
      { id: 'd3',  time: '', title: '先上水和小菜',                                  note: '' },
      { id: 'd4',  time: '', title: '上菜',                                          note: '' },
      { id: 'd5',  time: '', title: '收回餐具 → 马上清洗 · 消毒',                    note: '' },
      { id: 'd6',  time: '', title: '结账（现金 · 微信 · 支付宝 · 外卖平台）+ 保管小票', note: '小票放在一个盒子里' },
      { id: 'd7',  time: '', title: '检查洗手间（每 1 小时）',                        note: '' },
      { id: 'd8',  time: '', title: '随时看小菜还剩多少 · 及时补',                    note: '' },
      { id: 'd9',  time: '', title: '勤洗手 · 抹布每 30 分钟换一次',                  note: '' },
      { id: 'd10', time: '', title: '地上洒了 · 桌子脏了马上收拾',                    note: '' },
    ],
  },
  close: {
    label: '关店（营业结束后）',
    items: [
      { id: 'c1',  time: '', title: '确认最后一位客人已结账',                        note: '' },
      { id: 'c2',  time: '', title: '关燃气阀',                                      note: '确认两次' },
      { id: 'c3',  time: '', title: '清洁排烟罩',                                    note: '去掉油污' },
      { id: 'c4',  time: '', title: '剩下的食物收好 — 贴日期标签',                    note: '冷藏 2 天内用完' },
      { id: 'c5',  time: '', title: '所有餐具清洗 · 消毒完',                          note: '' },
      { id: 'c6',  time: '', title: '打扫地面 · 桌子 · 把椅子放上去',                  note: '' },
      { id: 'c7',  time: '', title: '厨余垃圾和其他垃圾分开扔',                        note: '' },
      { id: 'c8',  time: '', title: '打扫洗手间',                                    note: '' },
      { id: 'c9',  time: '', title: '收银对账 — 现金 · 微信 · 支付宝 · 外卖合计',       note: '有差额马上记下来' },
      { id: 'c10', time: '', title: '把今天的营业额告诉老板',                          note: '' },
      { id: 'c11', time: '', title: '检查明天要用的食材 → 不够的写订货单',             note: '在 SEMFIT 订货单里按供应商下单' },
      { id: 'c12', time: '', title: '再检查一次冰箱温度',                              note: '' },
      { id: 'c13', time: '', title: '关灯 · 关招牌电源',                               note: '' },
      { id: 'c14', time: '', title: '再确认燃气阀',                                    note: '再检查一次是否关好' },
      { id: 'c15', time: '', title: '锁门',                                            note: '' },
    ],
  },
};
